/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCrownIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-crown"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.7 21.8Q5.15 21.8 4.76 21.41Q4.38 21.02 4.38 20.48Q4.38 19.93 4.76 19.54Q5.15 19.15 5.7 19.15L18.32 19.15Q18.88 19.15 19.26 19.54Q19.65 19.93 19.65 20.48Q19.65 21.02 19.26 21.41Q18.88 21.8 18.32 21.8ZM6.67 17.65Q5.7 17.65 4.95 17.01Q4.2 16.38 4.05 15.4L3.02 8.85Q3.02 8.85 3.02 8.85Q3.02 8.85 3.02 8.85Q2.25 8.85 1.73 8.31Q1.2 7.78 1.2 7Q1.2 6.22 1.74 5.69Q2.27 5.15 3.05 5.15Q3.83 5.15 4.36 5.69Q4.9 6.22 4.9 7Q4.9 7.2 4.85 7.4Q4.8 7.6 4.72 7.78L7.7 9.1Q7.7 9.1 7.7 9.1Q7.7 9.1 7.7 9.1L10.97 4.55Q10.63 4.3 10.4 3.91Q10.18 3.52 10.18 3.05Q10.18 2.27 10.71 1.74Q11.25 1.2 12 1.2Q12.78 1.2 13.31 1.74Q13.85 2.27 13.85 3.05Q13.85 3.52 13.63 3.92Q13.4 4.33 13.03 4.58L16.32 9.1Q16.32 9.1 16.32 9.1Q16.32 9.1 16.32 9.1L19.3 7.78Q19.23 7.6 19.18 7.4Q19.13 7.2 19.13 7Q19.13 6.22 19.66 5.69Q20.2 5.15 20.98 5.15Q21.73 5.15 22.26 5.69Q22.8 6.22 22.8 7Q22.8 7.78 22.27 8.31Q21.75 8.85 21 8.85Q21 8.85 21 8.85Q21 8.85 21 8.85L19.95 15.43Q19.8 16.4 19.05 17.02Q18.3 17.65 17.32 17.65Z" fill={color} />
    </svg>
  );
}
